// app/components/BookGridItem.js
import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  Dimensions,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';

const { width } = Dimensions.get('window');

const BookGridItem = ({ book, onPress }) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <LinearGradient
        colors={['#667eea', '#764ba2']}
        style={styles.gradient}
      >
        <MaterialCommunityIcons name="book-open-variant" size={40} color="#ffffff" />
      </LinearGradient>
      <Text style={styles.title} numberOfLines={2}>
        {book.title || 'Book Title'}
      </Text>
      <Text style={styles.subtitle} numberOfLines={1}>
        {book.author || 'Author'}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: (width - 48) / 2,
    marginBottom: 16,
    marginHorizontal: 8,
  },
  gradient: {
    width: '100%',
    height: 150,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 12,
    color: '#6b7280',
  },
});

export default BookGridItem;